export default "assets/images/v_medaille-06f5165c.png";